import React from "react";
import { Link } from "react-router-dom";
import LoginIcon from "@material-ui/icons/LockOpen";
import CreateIcon from "@material-ui/icons/Create";
import NavLink from "@material-tailwind/react/NavLink";
import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import Contactus from "@material-ui/icons/ContactSupport";

export default function Landing() {
  return (
    <>
      <Navbar transparent />
      <main>
        <div className="pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                "url(" + require("../assets/img/security.jpg").default + ")",
            }}
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-75 bg-black"
            ></span>

            <div className="right2">
              <Link to="/auth/login" style={{ color: "white" }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <LoginIcon />
                Login
              </Link>

              <Link to="/auth/register" style={{ color: "white" }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <CreateIcon />
                Register
              </Link>
              <a
                style={{ color: "white" }}
                href="https://support.zippyops.com/"
                target="_blank"
                rel="noreferrer"
                ripple="light"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Contactus />
                Support
              </a>
              <a
                style={{ color: "white" }}
                href="https://docs.automatecis.com/"
                target="_blank"
                rel="noreferrer"
                ripple="light"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;
                <LibraryBooksIcon />
                Docs
              </a>
            </div>
          </div>
          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-6 ml-auto mr-auto text-center">
                <div className="pr-12">
                  <img
                    alt="..."
                    style={{
                      height: "150px",
                      width: "120px",
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",
                    }}
                    src={
                      require("../assets/img/theme/squarewhitewithtag1.png")
                        .default
                    }
                  />
                  <p className="mt-4 text-lg text-blueGray-200">
                    <span style={{ color: "springgreen", fontSize: "x-large" }}>
                      {" "}
                      AutomateCIS is the world first SaaS platform to{" "}
                    </span>
                    <br />
                    <br />
                    Audit your IT infrastructure against CIS Benchmarks.
                    <br />
                    Automatically enforce the audit policy for continuous
                    compliance.
                    <br />
                    Rollback any changes enforced by AutomateCIS.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </div>

        <section className="pb-20 bg-blueGray-200 -mt-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap">
              <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                      <i className="fas fa-award"></i>
                    </div>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Centralized dashboard to track your compliance status
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
                      <i className="fas fa-plug"></i>
                    </div>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      No need to install any agent on the servers, supports SSH
                      or WinRM connectivity
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
                      <i className="fas fa-dollar-sign"></i>
                    </div>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      No upfront fee, No hidden charges, no suspicious plans,
                      pay as per your usage
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center mt-32">
              <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                  <i className="fas fa-user-friends text-xl"></i>
                </div>
                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                  AutomateCIS
                </h3>
                <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                  Safeguarding IT systems against cyber threats would take a lot
                  of time and require many meetings between IT and Security
                  teams to debate and finalize the compliance standards.
                </p>
                <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600">
                  Center For Information Security (CIS) has developed CIS
                  Benchmarks for operating systems, applications, and cloud
                  platforms. But applying them to individual systems and
                  auditing their current state is impracticable.
                </p>
                <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600">
                  AutomateCIS can do the heavy lifting of keeping your
                  infrastructure up to date with CIS standards in a few simple
                  steps.
                </p>
              </div>
              <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-lightBlue-500">
                  <img
                    alt="..."
                    src="https://assets.rbl.ms/25591710/origin.jpg"
                    className="w-full align-middle rounded-t-lg"
                  />
                  <blockquote className="relative p-8 mb-4">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block h-95-px -top-94-px"
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-lightBlue-500 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white">
                      OS Supported
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      AutomateCIS Can Audit and Remediate all major Windows and
                      Linux operating systems
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <style jsx="true" >{`
        header {
          margin-bottom: 1rem;
          height: 100vh;
        }
        .right {
          position: absolute;
          top: -150px;
          right: 100px;
        }

        .right2 {
          position: absolute;
          top: 20px;
          right: 50px;
          font-size: 15px;
        }

        .right3 {
          position: absolute;
          top: 8px;
          right: 300px;
          font-size: 20px;
        }

        .top {
          position: absolute;
          top: -150px;
          right: 100px;
        }

        .left {
          position: absolute;
          top: 20px;
          // left: 10px;
        }
      `}</style>
    </>
  );
}
